import React, { useState, useEffect } from 'react';


function Button() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={showButton ? 'back-to-top-button show' : 'back-to-top-button'}>
      <button onClick={handleClick}>
      <i class='fa-solid fa-arrow-up-long'></i> 
    
      </button>
    </div>
  );
}

export default Button;
